import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';
import Modal from '../../components/Modal';
import Logo from '../../../../assets/images/squire-logo-light.svg';
import PaymentModalTip from '../containers/PaymentModalTip';
import PaymentModalOrderInformation from '../containers/PaymentModalOrderInformation';
import ReedemCode from '../containers/PaymentModalReedemCode';
import PaymentFormPayFac from '../containers/PaymentFormContainerPayFac';
import PaymentFormStripe from '../containers/PaymentFormContainerStripe';
import PaymentFormWithoutCard from './PaymentFormWithoutCard';
import PromoTidalCheckout from '../containers/PromoTidalCheckout';
import { nullFunc } from '../../utils/helpers';

// preloads payment modal's fonts so stuff inside is not jumping around when opening the first time
export const FontsPreloader = () => (
  <div style={{ opacity: 0 }}>
    <span style={{ fontFamily: 'Open Sans', fontWeight: '300' }} />
    <span style={{ fontFamily: 'Open Sans', fontWeight: '400' }} />
    <span style={{ fontFamily: 'Open Sans', fontWeight: '700' }} />
    <link rel="preload" href="https://fonts.gstatic.com/s/opensans/v17/mem8YaGs126MiZpBA-UFVZ0bf8pkAg.woff2" />
  </div>
);

const CheckoutModal = (props) => {
  const isReserveAndPay = props.action === 'reserveAndPay';
  const gridClassName = (
    (isReserveAndPay || !props.tipEnabled) ? 'c-payment-modal-tip-grid__no-tip' : 'c-payment-modal-tip-grid'
  );
  const backdropStyles = (
    props.toggled ? { backdropFilter: 'blur(5px)', animation: '.1s modal-in forwards' } : { display: 'none' }
  );

  return (
    <div>
      <Modal
        className={cx('c-checkout-modal', { 'is-hidden': !props.toggled })}
        backdropStyles={backdropStyles}
        close={noop}
      >
        <span className="c-checkout-modal__lock" />
        {
          !props.formDisabled && props.off && (
            <button className="c-checkout-modal__close" onClick={props.onBeforeClose && props.off} />
          )
        }
        <div className="c-checkout-modal__header">
          <img src={Logo} alt="Squire" />
        </div>
        <div className={gridClassName}>
          {!isReserveAndPay && <PaymentModalTip tipEnabled={props.tipEnabled} />}
          <div className="u-flex u-flex-column u-justify-content-space-between">
            <PaymentModalOrderInformation action={props.action} kioskMode={props.kiosk} />
            <ReedemCode />
          </div>
          {
            !props.canBeChargedWithSavedCard && props.isPayFacBrand && <PaymentFormPayFac
              amount={props.totalAmount}
              panelLabel={props.panelLabel}
              confirmSetup={props.confirmSetup}
              formDisabled={props.formDisabled}
              hasErrors={props.hasErrors}
              isCoveredByDiscount={props.isCoveredByDiscount}
              disableApplePay={isReserveAndPay || props.isReservation}
            />
          }
          {
            !props.canBeChargedWithSavedCard && !props.isPayFacBrand && <PaymentFormStripe
              amount={props.totalAmount}
              panelLabel={props.panelLabel}
              buttonLabel={props.isReservation ? 'Reserve' : null}
              confirmSetup={props.confirmSetup}
              formDisabled={props.formDisabled}
              hasErrors={props.hasErrors}
              isCoveredByDiscount={props.isCoveredByDiscount}
              disableApplePay={isReserveAndPay || props.isReservation}
            />
          }
          {
            props.canBeChargedWithSavedCard && <PaymentFormWithoutCard
              formDisabled={props.formDisabled}
              amount={props.totalAmount}
              hasErrors={props.hasErrors}
              confirmSetup={props.confirmSetup}
              panelLabel="Charge"
            />
          }
        </div>
        {props.showPromo && <PromoTidalCheckout />}
      </Modal>
    </div>
  );
};

CheckoutModal.propTypes = {
  formDisabled: PropTypes.bool.isRequired,
  totalAmount: PropTypes.number.isRequired,
  confirmSetup: PropTypes.func.isRequired,
  panelLabel: PropTypes.string,
  toggled: PropTypes.bool,
  hasErrors: PropTypes.bool.isRequired,
  isCoveredByDiscount: PropTypes.bool.isRequired,
  off: PropTypes.func,
  canBeChargedWithSavedCard: PropTypes.bool,
  action: PropTypes.string.isRequired,
  tipEnabled: PropTypes.bool.isRequired,
  showPromo: PropTypes.bool,
  onBeforeOpen: PropTypes.func, // eslint-disable-line
  onBeforeClose: PropTypes.func,
  isPayFacBrand: PropTypes.bool,
  kiosk: PropTypes.bool,
  isReservation: PropTypes.bool,
};

CheckoutModal.defaultProps = {
  panelLabel: 'Pay',
  off: undefined,
  toggled: true,
  canBeChargedWithSavedCard: false,
  showPromo: false,
  onBeforeOpen: nullFunc,
  onBeforeClose: nullFunc,
  isPayFacBrand: false,
  kiosk: false,
};

export default CheckoutModal;



// WEBPACK FOOTER //
// ./src/app/reservation/components/CheckoutModal.jsx